import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import initialState from './initialState';

export default {
  mutations,
  actions,
  getters,
  state: initialState,
};
